export const WHATSAPP_LINK =
  "https://wa.me/19549559868?text=Hello%20Spark%20Plug%20team%2C%20I%20would%20like%20to%20inquire%20about%20your%20services.";
export const STACKCP_URL = process.env.REACT_APP_STACKCP_URL || "https://stackcp.com";
export const PHONE_DISPLAY = "+1 (954) 955-9868";
export const ALT_PHONE_DISPLAY = "+1 (754) 755-1717";
export const ADDRESS = "3175 W Broward Blvd, Fort Lauderdale, FL 33312";
export const EMAIL = "hello@sparkplug.agency";

export const SOCIALS = [
  { id: "facebook", label: "Facebook", href: "#" },
  { id: "instagram", label: "Instagram", href: "#" },
  { id: "tiktok", label: "TikTok", href: "#" },
  { id: "x", label: "X", href: "#" },
  { id: "linkedin", label: "LinkedIn", href: "#" },
];

export const SERVICE_OPTIONS = [
  { value: "general", label: "General Inquiry" },
  { value: "digital-marketing", label: "Digital Marketing" },
  { value: "website-development", label: "Website Development" },
  { value: "app-development", label: "App Development" },
  { value: "hosting-domain", label: "Hosting / Domain" },
  { value: "all-in-one", label: "All-In-One Package" },
];

export const SERVICES = [
  {
    id: "digital-marketing",
    name: "Digital Marketing",
    blurb:
      "SEM, SMM, SEO and WhatsApp funnels engineered to turn raw attention into booked revenue.",
    points: ["Search & social campaigns", "SEO that compounds", "WhatsApp lead funnels"],
    span: "lg:col-span-2",
  },
  {
    id: "website-development",
    name: "Website Development",
    blurb:
      "Premium, conversion-first websites built on modern stacks — fast, secure, and made to sell.",
    points: ["Custom design & build", "Blazing performance", "Conversion architecture"],
    span: "",
  },
  {
    id: "app-development",
    name: "App Development",
    blurb:
      "Native-quality iOS and Android apps, from MVP sprint to App Store launch and beyond.",
    points: ["iOS & Android", "MVP to scale", "Ongoing iteration"],
    span: "",
  },
  {
    id: "domain-registration",
    name: "Domain Registration",
    blurb:
      "Secure the right name before someone else does. Inquiry-only — we handle the paperwork.",
    points: ["Name strategy", "Transfer handling", "DNS managed for you"],
    span: "",
  },
  {
    id: "shared-hosting",
    name: "Shared Hosting",
    blurb:
      "High-speed SSD hosting with a 99.9% uptime guarantee, daily backups, and real humans on support.",
    points: ["99.9% uptime SLA", "Daily backups", "Free SSL"],
    span: "",
  },
  {
    id: "all-in-one",
    name: "All-In-One Website Package",
    blurb:
      "Design, development, domain, hosting, SEO kickoff and WhatsApp leads — one plug, full power.",
    points: ["Turnkey launch", "Single point of contact", "Inquiry-only pricing"],
    span: "lg:col-span-3",
    featured: true,
  },
];

export const HOSTING_PLANS = [
  {
    id: "starter",
    name: "Shared Hosting Starter",
    price: 199,
    tagline: "Everything a growing business needs to get online — properly.",
    features: [
      "Fast SSD storage",
      "Free SSL certificate",
      "Daily automated backups",
      "99.9% uptime guarantee",
      "Professional email accounts",
      "Easy control panel",
    ],
    testid: "hosting-plan-starter",
  },
  {
    id: "expert",
    name: "Shared Hosting Expert",
    price: 249,
    tagline: "More power, priority support, and your domain on us.",
    popular: true,
    features: [
      "Everything in Starter",
      "Double SSD storage",
      "Priority support queue",
      "Free domain registration",
      "Performance optimization",
      "Staging environment",
    ],
    testid: "hosting-plan-expert",
  },
];

export const MARKETING_TABS = [
  {
    id: "sem",
    label: "SEM",
    title: "Search Engine Marketing",
    stat: "3.4x",
    statLabel: "average return on ad spend",
    description:
      "Google Ads and paid search campaigns built around intent, not vanity clicks. Every dollar tracked from impression to invoice.",
    points: ["Keyword & intent mapping", "Landing page alignment", "Weekly bid optimization"],
  },
  {
    id: "smm",
    label: "SMM",
    title: "Social Media Marketing",
    stat: "12M+",
    statLabel: "impressions generated for clients",
    description:
      "Scroll-stopping content and paid social across Facebook, Instagram, TikTok, X and LinkedIn — built for your audience, not the algorithm's.",
    points: ["Content engines", "Paid social funnels", "Community management"],
  },
  {
    id: "seo",
    label: "SEO",
    title: "Search Engine Optimization",
    stat: "Top 3",
    statLabel: "rankings for priority keywords",
    description:
      "Technical SEO, content strategy and authority building that compounds month over month. Traffic you own, not rent.",
    points: ["Technical audits", "Content strategy", "Authority building"],
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    title: "WhatsApp Marketing",
    stat: "68%",
    statLabel: "average open-to-reply rate",
    description:
      "Direct WhatsApp funnels that meet customers where they actually respond. Click-to-chat ads, automated follow-ups, instant quotes.",
    points: ["Click-to-chat campaigns", "Automated follow-ups", "Broadcast funnels"],
  },
];

export const PORTFOLIO = [
  {
    id: "visibility",
    title: "Visibility Engine",
    headline: ["make your", "brand visible"],
    category: "Digital Marketing — SEO & SEM",
    description:
      "SEO, paid search and social campaigns that put your website in front of the people already searching for you — and keep it there.",
    metric: "Top 3",
    metricLabel: "search rankings",
    tags: ["SEO", "SEM", "SMM"],
    image: "/assets/visibility.png",
  },
  {
    id: "atlas",
    title: "Atlas Supply Co.",
    headline: ["commerce engines", "built to scale"],
    category: "E-Commerce — Growth Engine",
    description:
      "A next-generation storefront with SEO and paid search fused into one growth engine — 3.1x revenue in nine months.",
    metric: "3.1x",
    metricLabel: "revenue growth",
    tags: ["Next-Gen Storefront", "SEO", "SEM"],
    image:
      "https://images.unsplash.com/photo-1634084462412-b54873c0a56d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjB3ZWIlMjBkZXNpZ24lMjBhcHAlMjBkZXZlbG9wbWVudCUyMHBvcnRmb2xpbyUyMHNob3djYXNlfGVufDB8fHx8MTc4OTE1Nzg0Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pulsefit",
    title: "PulseFit",
    headline: ["apps your users", "open daily"],
    category: "Mobile App — iOS & Android",
    description:
      "A native-quality fitness platform for iOS and Android with push funnels that keep members hooked — 4.9 stars and climbing.",
    metric: "4.9",
    metricLabel: "star app rating",
    tags: ["iOS", "Android", "Push Funnels"],
    image:
      "https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3ZWIlMjBkZXNpZ24lMjBhcHAlMjBkZXZlbG9wbWVudCUyMHBvcnRmb2xpbyUyMHNob3djYXNlfGVufDB8fHx8MTc4OTE1Nzg0Mnww&ixlib=rb-4.1.0&q=85",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "High-Velocity Engineering",
    body: "We ship fast without breaking things. Modern stacks, clean code, and performance budgets on every build — because a one-second delay costs you real customers.",
    points: ["Sub-2s load targets", "Modern React & FastAPI stacks", "Performance budgets enforced"],
  },
  {
    num: "02",
    title: "Conversion-First Design",
    body: "Beautiful is table stakes. Every layout, headline and button placement is engineered around one question: does it move a visitor closer to contacting you?",
    points: ["CTA-driven layouts", "Trust signals by design", "Mobile-first, always"],
  },
  {
    num: "03",
    title: "Turnkey Hosting & Infrastructure",
    body: "Domain, hosting, SSL, backups, email — handled under one roof with a 99.9% uptime guarantee. You never touch a server. You never chase five vendors.",
    points: ["99.9% uptime SLA", "Daily backups included", "One team, one invoice"],
  },
  {
    num: "04",
    title: "Transparent Growth Partner",
    body: "No black-box retainers. You see what we do, what it costs, and what it returns — in plain English, on a real call, with a real human in Fort Lauderdale.",
    points: ["Plain-English reporting", "No lock-in contracts", "Direct WhatsApp line"],
  },
];

export const BLOG_POSTS = [
  {
    slug: "seo-compounds",
    category: "SEO",
    readTime: "6 min",
    date: "Jul 2026",
    title: "Why SEO Compounds — and Ads Don't",
    excerpt:
      "Paid traffic stops the moment you stop paying. Here's how organic search builds an asset your competitors can't outbid.",
  },
  {
    slug: "speed-is-a-feature",
    category: "Web Performance",
    readTime: "5 min",
    date: "Jul 2026",
    title: "Your Website's Speed Is a Feature",
    excerpt:
      "Every extra second of load time bleeds conversions. The performance budget we enforce on every Spark Plug build.",
  },
  {
    slug: "mvp-to-scale",
    category: "App Development",
    readTime: "8 min",
    date: "Jun 2026",
    title: "From MVP to Scale Without a Rewrite",
    excerpt:
      "The architecture decisions that let your app grow from 100 users to 100,000 without burning it down first.",
  },
  {
    slug: "domain-strategy",
    category: "Domains",
    readTime: "4 min",
    date: "Jun 2026",
    title: "The Domain Strategy Most Businesses Skip",
    excerpt:
      "Your domain is brand infrastructure. How to choose, secure, and protect the right name before someone else does.",
  },
  {
    slug: "cro-basics",
    category: "Conversion",
    readTime: "7 min",
    date: "May 2026",
    title: "Conversion Rate Optimization for Skeptics",
    excerpt:
      "No growth-hacker jargon. Five structural changes that reliably turn more visitors into inquiries.",
  },
  {
    slug: "whatsapp-funnels",
    category: "WhatsApp Marketing",
    readTime: "5 min",
    date: "May 2026",
    title: "WhatsApp Funnels Beat Contact Forms",
    excerpt:
      "68% reply rates versus 2% form fills. Why the fastest-growing businesses move the conversation to chat.",
  },
];

export const MARQUEE_ITEMS = [
  "Digital Marketing",
  "Web Development",
  "App Architecture",
  "Domain & Hosting",
  "All-In-One Growth Platforms",
  "SEO That Compounds",
  "WhatsApp Lead Funnels",
];

export const TEAM_IMAGE =
  "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5JTIwdGVhbSUyMHBvcnRmb2xpbyUyMHdlYnNpdGUlMjB0ZWNofGVufDB8fHx8MTc4OTE1NzgzNXww&ixlib=rb-4.1.0&q=85";
export const WORKSPACE_IMAGE =
  "https://images.unsplash.com/photo-1702047149248-a6049168d2a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHx0ZWNoJTIwc3RhcnR1cCUyMHRlYW0lMjB3b3Jrc3BhY2UlMjBkZXNrJTIwZGFyayUyMG1vZGV8ZW58MHx8fHwxNzg5MTU3ODQyfDA&ixlib=rb-4.1.0&q=85";
